import { CSSProp } from "styled-components";

export const activityTextDefaultStyle = {
  wordBreak: "break-word",
  paddingRight: "8px",
} as CSSProp;
